import React from 'react';
import PropTypes from 'prop-types';


const LoadingIndicator = ({ className = 'bb-loading-indicator-wrapper' }) => (
    <div className={className}>
        <div className="bb-loading-indicator" />
    </div>
);

LoadingIndicator.propTypes = {
    className: PropTypes.string,
};

export default LoadingIndicator;
